// extracted by mini-css-extract-plugin
module.exports = {"roundGrid":"RoundGrid_roundGrid__3_H0T","title":"RoundGrid_title__zZoxA","subtitle":"RoundGrid_subtitle__wWJ7p","gridContent":"RoundGrid_gridContent__MS4Eb"};